module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-concentrates-icon-2-b6bf63e07973851e324a953ad99d7820.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-concentrates-icon-2.svg
 ** module id = 1044
 ** module chunks = 1 76
 **/